import React from "react";

import Heading from "core/Heading";
import DeniedGrid from "./DeniedGrid";

import { GET_ALL_DENIED_PHOTO_SUBMISSIONS } from "./queries";

import useLoadMore from "frontend/hooks/useLoadMore";

const SubmissionsDenied = () => {
    const { items, totalCount, LoadMore } = useLoadMore({
        query: GET_ALL_DENIED_PHOTO_SUBMISSIONS,
        pathToListKey: "allDeniedPhotoSubmissions.items",
        pathToTotalCountKey: "allDeniedPhotoSubmissions.totalCount",
        limit: 50
    });

    let content = null;

    if (!totalCount) {
        content = <Heading size="md">No photos have been denied.</Heading>;
    } else {
        content = (
            <>
                <DeniedGrid listData={items} />
                <LoadMore buttonText="Load More" />
            </>
        );
    }

    return <div data-testid="submissions-denied">{content}</div>;
};

export default SubmissionsDenied;
